import { useEffect, useState } from 'react'
import Select from 'react-tailwindcss-select'

const types = [
  { value: false, label: 'نشيطة' },
  { value: true, label: 'غير نشيطة' },
]

export default function SelectOpportunityStatusTypes({
  defaultValue,
  onChange,
}) {
  const [selectedType, setSelectedType] = useState(defaultValue ?? false)

  useEffect(() => {
    const defaultType = types.find((type) => type.value === defaultValue)
    setSelectedType(defaultType ?? false)
  }, [defaultValue])

  const handleOnChange = (option) => {
    setSelectedType(option)
    onChange(option?.value ?? false)
  }

  return (
    <Select
      value={selectedType}
      onChange={handleOnChange}
      options={types}
      placeholder="نوع المعدن..."
      classNames={{
        menuButton: ({ isDisabled }) =>
          `focus:outline-none border-2 border-muted-500 py-0.5 pr-3 flex bg-white`,
        searchContainer: 'relative w-full',
        searchBox:
          'w-full outline-none px-2 border-2 border-muted py-2 bg-light',
        menu: `absolute z-50 -mt-1 w-full shadow-lg bg-white border-2 border-muted-500 py-2  `,
      }}
      formatOptionLabel={(data) => (
        <li
          className={`z-50 line-clamp-1 block cursor-pointer select-none px-4 py-3 ${data.isSelected ? `bg-accent-600 text-white` : `hover:bg-accent-600 hover:text-white`}`}
        >
          <div className="flex items-center">
            <div>{data.label}</div>
          </div>
        </li>
      )}
    />
  )
}
